export const staticLanguages = [
  'English', 'Spanish', 'French'
]

export const staticDeveloperCompanies = [
  'Developer Company One', 'Developer Company Two'
]
